export const mainBlue = '#3f51b5'
export const secondaryBlue = '#53A1FF'
export const darkBlue = '#161832'
export const greyBlue = '#4f88b5'
export const lightBlue = '#9BC2E6'
export const lightGrey = 'rgb(208, 208, 208)'
export const mediumGrey = '#75838F'
export const strongGrey = '#5c5c5c'
export const disabledColor = '#949494'
export const selectedColor = '#e0e0e0'
export const mainWhite = '#fafafa'
export const mainRed = '#f32525'

export const chartGrey = 'rgb(163, 163, 163)'
export const defaultMonitoringColor = '#0087FF'

export const THRESHOLD_COLORS_CODES = {
    BLACK: '#000000',
    BLUE: '#0000FF',
    GREEN: '#008000',
    CYAN: '#00FFFF',
    RED: '#FF0000',
    DARK_MAGENTA: '#8B008B',
    YELLOW: '#FFFF00',
    WHITE: '#FFFFFF',
    GREY: '#808080',
    LIGHT_BLUE: '#ADD8E6',
    LIGHT_GREEN: '#90EE90',
    LIGHT_CYAN: '#E0FFFF',
    INDIANRED: '#CD5C5C',
    MAGENTA: '#FF00FF',
    LIGHT_YELLOW: '#FFFFE0',
    WHITE_SMOKE: '#F5F5F5',
}

export const INDICATORS_COLORS = {
    BLUE: '#8fabdd',
    YELLOW: '#ffe699',
    RED: '#fe6869',
    GREY: '#a4a5a4',
    BLACK: '#404040',
}